import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useRentalFilesStore = create()(
    persist(
        (set, get) => ({
            refetchRentalFiles: false,
            storeRefetchRentalFiles: (refetchRentalFiles) => set(() => ({ refetchRentalFiles: refetchRentalFiles })),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query })),
            editedRemoteCollectionById: {},
            storeEditedRemoteCollection: (remoteCollectionId, editedRemoteCollection) => set((state) => ({
                editedRemoteCollectionById: {
                    ...state.editedRemoteCollectionById,
                    [remoteCollectionId]: editedRemoteCollection
                }
            })),
            getEditedRemoteCollection: (remoteCollectionId) => get().editedRemoteCollectionById[remoteCollectionId]
        }),
        {
            name: 'rental-files-storage'
        }
    )
);


export default useRentalFilesStore;